var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    fill: "#393939",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5725714,16.25 C15.4989293,16.25 16.25,15.4989293 16.25,14.5725714 L16.25,3.42742857 C16.25,2.50107071 15.4989293,1.75 14.5725714,1.75 L3.42742857,1.75 C2.50107071,1.75 1.75,2.50107071 1.75,3.42742857 L1.75,14.5725714 C1.75,15.4989293 2.50107071,16.25 3.42742857,16.25 L14.5725714,16.25 Z M14.5725714,17.75 L3.42742857,17.75 C1.67264358,17.75 0.25,16.3273564 0.25,14.5725714 L0.25,3.42742857 C0.25,1.67264358 1.67264358,0.25 3.42742857,0.25 L14.5725714,0.25 C16.3273564,0.25 17.75,1.67264358 17.75,3.42742857 L17.75,14.5725714 C17.75,16.3273564 16.3273564,17.75 14.5725714,17.75 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    points: "1 7.25 1 5.75 17 5.75 17 7.25"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.5495f4f1f35c72487438ca5f0d7e9d98.svg";
export { ForwardRef as ReactComponent };